module.exports = __webpack_public_path__ + "img/amplifiers-2023.e9a7ad94.jpg";